export default [
  {
    field: 'personalTitle',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'personalTitle',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
  {
    field: 'maritalStatus',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'maritalStatus',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
];
